// 전표 조회
export const LOAD_SLIP = "LOAD_SLIP"; // 전표상세
export const LOAD_SLIP_LIST = "LOAD_SLIP_LIST"; // 전표목록
export const LOAD_SLIP_METHOD = "LOAD_SLIP_METHOD"; // 전표 결제수단 
export const LOAD_SLIP_REMAIN_LIST = "LOAD_SLIP_REMAIN_LIST"; // 외상전표목록
export const UNLOAD_SLIP = "UNLOAD_SLIP";
export const GET_TRANS_CATE_LIST = "GET_TRANS_CATE_LIST";
export const GET_METHOD_LIST = "GET_METHOD_LIST";
export const SAVE_SLIP = 'SAVE_SLIP';
export const DELETE_SLIP = 'DELETE_SLIP';
export const INIT_SLIP_STATUS = 'INIT_SLIP_STATUS';
export const OPEN_TOP_DELETE = 'OPEN_TOP_DELETE';
export const RUN_TOP_DELETE = 'RUN_TOP_DELETE';
export const SEARCH_DATA = 'SEARCH_DATA';
export const LOAD_SCRAP = 'LOAD_SCRAP';
export const SAVE_SLIP_SCRAP = 'SAVE_SLIP_SCRAP';
export const SAVE_SLIP_REMAIN = 'SAVE_SLIP_REMAIN';
export const UNLOAD_SLIP_REMAIN = 'UNLOAD_SLIP_REMAIN';
export const LOAD_SLIP_REMAIN_DETAIL = 'LOAD_SLIP_REMAIN_DETAIL';
export const UNLOAD_SLIP_MAIN = 'UNLOAD_SLIP_MAIN';
export const LOAD_SLIP_PHOTO = 'LOAD_SLIP_PHOTO';
export const UNLOAD_SLIP_PHOTO = 'UNLOAD_SLIP_PHOTO';


// WEBPACK FOOTER //
// ./src/constants/slip.js